// extracted by mini-css-extract-plugin
export default {"wrapper":"CountElement_wrapper__2FZ+y","title":"CountElement_title__JS8aT","numValue":"CountElement_numValue__lVh5-"};